import type { ReactNode } from 'react';

import { Label } from '@connected/ui/components/label';
import { Switch } from '@connected/ui/components/switch';
import { cn } from '@connected/ui/lib/utils';

export type SwitchFieldProps = {
    name?: string;
    value: boolean;
    label: ReactNode;
    handleChange: (value: boolean) => void;
};

export function SwitchField({
    name,
    value,
    label,
    className,
    handleChange,
    disabled = false,
    ...props
}: SwitchFieldProps & Omit<React.HTMLProps<HTMLLabelElement>, keyof SwitchFieldProps | 'ref'>) {
    return (
        <Label
            className={cn(
                'flex h-10 cursor-pointer items-center gap-2 pl-2',
                className,
            )}
            {...props}

        >
            <Switch
                name={name}
                disabled={disabled}
                checked={value}
                onCheckedChange={handleChange}
            />
            <span>{label}</span>
        </Label>
    );
}
